import { SaveType, BaseModel } from "@puntaje/shared/core"

export class PlanPersonalContenidoGrupoUsuario extends BaseModel {
    public plan_personal_contenido_id: number
    public grupo_usuario_id: number
    public visto: boolean
    public marcado: boolean
}
